export default {
    newDesign: true,
    parameters: {
        landing_id: "LatQuFTSI",
        segment: 14,
    },
    title:
        "Responde a 4 preguntas y recibe una clase gratuita para tu hijo/a de 5 a 17 años | Kodland",
    downtimeUrl: "https://www.kodland.org/es",
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "¡Gracias por confiar en nuestra plataforma educativa!",
        subtitle:
            "Lamentablemente, las tabletas y los teléfonos no son adecuados para nuestras clases. ¡Esperamos verte en nuestras lecciones en otra ocasión!",
    },
    quizRotateBySteps: {
        1: {
            question:
                "¿Te gustaría que el tiempo que tu hijo/a pasa en la computadora fuera más productivo?",
            answers: [
                "🔥 ¡Si!",
                "🤗 No. Lo hace solo para divertirse y eso está bien",
            ],
            coverImageDesk: {
                url: "/welcome/quiz_peru.png",
            },
            coverImageMob: {
                url: "/welcome/quiz_peru_mobile.png",
            },
            isCover: true,
        },
        2: {
            question: "¿Cuáles son las habilidades de tu hijo/a con la computadora/portátil?",
            answers: [
                "👍 No tiene conocimientos, debe estudiar lo básico",
                "🙌 Nivel básico, sabe usar Power Point y otras aplicaciones",
                "🖥 Nivel intermedio, quiere profundizar conocimientos",
                "🕹 Usa los dispositivos más que nada para juegos",
            ],
        },
        3: {
            question:
                "En estos momentos, ¿Que es lo más importante para ti en el desarrollo de tu hijo/a?",
            answers: [
                "🤔 Habilidades blandas",
                "🎓 Preparación para una carrera a futuro",
                "🖥 Actividades extracurriculares",
            ],
        },
        4: {
            question: "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
            answers: [
                "💻 Sí",
                {
                    answer: "😐 No",
                    stopAnswer: true
                },
            ],
        },
        5: {
            title: "🎉 ¡Solo un paso más!",
            typeInfo: "congrats",
            subtitle:
                "Ayuda a tu hijo a explorar su lado creativo con programación y diseño digital.<br>🌟 Ya son más de 200.000 niños creando y aprendiendo con nosotros.",
            button: "📅 ¡Reserva una clase gratis!",
        },
        6: {
            title: "Reserva una clase gratuita",
            type: "one-page-contacts",
            subtitle: "",
            button: "Casi terminamos 🔥",
        },
        7: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        8: {
            title: "Revisa estos detalles para completar el registro ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
            button: "¿Qué más?",
        },
        9: {
            title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
            typeInfo: "whatsapp",
            subtitle:
                "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
            button: "¿Qué más?",
        },
        10: {
            title: "La clase se realizará en nuestra plataforma 💻",
            typeInfo: "classroom",
            subtitle:
              "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
            button: "Entendido ✅",
        },
    },
};
